import { render, staticRenderFns } from "./Report-groupclass.vue?vue&type=template&id=066117a9&"
import script from "./Report-groupclass.vue?vue&type=script&lang=js&"
export * from "./Report-groupclass.vue?vue&type=script&lang=js&"
import style0 from "./Report-groupclass.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Report-groupclass.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports